import React, { useContext } from 'react';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Container } from '@comparethemarketau/manor-grid';

import { ComparisonTitle } from './common/comparison_title';
import { ComparisonSubTitle } from './common/comparison_sub_title';
import { ComparisonProducts } from './widget/comparison_products';
import { BackToResultsButton } from './common/back_to_results_button';

const useStyles = createUseStyles((theme) => ({
    title: {
        marginLeft: '1.5rem',
        fontSize: theme.fontSize['2xl']
    },
    subTitle: {
        marginLeft: '1.5rem',
        fontSize: theme.fontSize.xs,
        marginTop: '2rem'
    },
    products: {
        marginTop: theme.spacing[16]
    },
    backButtonTop: {
        marginLeft: '2.6rem',
        marginBottom: theme.spacing[32]
    },
    backButtonBottom: {
        marginTop: '4.8rem',
        width: '30.8rem',
        alignSelf: 'center'
    }
}));

const PolicyComparisonXs = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    return (
        <Container padding={['16', '0', '16', '0']} className={classNames('test-policyComparison-xs')}>
            <BackToResultsButton variant="tertiary" className={classes.backButtonTop} />
            <ComparisonTitle className={classes.title} />
            <ComparisonSubTitle className={classes.subTitle} />
            <ComparisonProducts className={classes.products} />
            <BackToResultsButton label="Back to all results" variant="primary" className={classes.backButtonBottom} />
        </Container>
    );
};

export { PolicyComparisonXs };
